import store from '@/store'
import Home from '@/pages/Home.vue'
import clientRoutes from './client/routes'
import userRoutes from './user/routes'

const loadSession = (type, next) => {
  store.dispatch('getCurrentSession', type).then(session => {
    if (session) {
      next({ name: `${type}Dashboard`, params: { loaded: true } })
    } else {
      next()
    }
  })
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: 'page-404' */ '@/pages/Page404.vue')
  },
  {
    path: '/user/sign_in',
    name: 'userSignIn',
    beforeEnter: (to, from, next) => loadSession('user', next),
    component: () => import(/* webpackChunkName: 'user-authentication' */ '@/pages/user/SignIn.vue')
  },
  {
    path: '/user/sign_up',
    name: 'userSignUp',
    component: () => import(/* webpackChunkName: 'user-authentication' */ '@/pages/user/SignUp.vue')
  },
  {
    path: '/user/reset_password',
    name: 'userResetPassword',
    component: () => import(/* webpackChunkName: 'user-password' */ '@/pages/user/ResetPassword.vue')
  },
  {
    path: '/client/sign_in',
    name: 'clientSignIn',
    beforeEnter: (to, from, next) => loadSession('client', next),
    component: () => import(/* webpackChunkName: 'client-authentication' */ '@/pages/client/SignIn.vue')
  },
  {
    path: '/client/sign_up',
    name: 'clientSignUp',
    component: () => import(/* webpackChunkName: 'client-authentication' */ '@/pages/client/SignUp.vue')
  },
  {
    path: '/client/reset_password',
    name: 'clientResetPassword',
    component: () => import(/* webpackChunkName: 'client-password' */ '@/pages/client/ResetPassword.vue')
  },
  clientRoutes,
  userRoutes
]

export default routes
